import { getExchangeServerVersionInfo } from 'owa-session-data-stash';

export default function isSortingPersisted(): Boolean {
    const exchangeVersion = getExchangeServerVersionInfo();
    // Remove the version check after 15.20.1807 is deployed WW
    // This is needed to match what server sorts when sending SessionData responses
    return (
        exchangeVersion &&
        (exchangeVersion.MajorVersion > 15 ||
            exchangeVersion.MinorVersion > 20 ||
            exchangeVersion.MajorBuildNumber >= 1807)
    );
}
